import css from "./style.module.css";
import { useEffect, useState } from "react";
import {
  addAdmin,
  fetchAdmins,
  sendfeedback,
  fetchfeedback,
  deleteAdmin,
} from "../../api";
const AdminSettings = () => {
  const [admins, setAdmins] = useState([]);
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");

  // Загрузка списка администраторов
  useEffect(() => {
    const loadAdmins = async () => {
      const response = await fetchAdmins();
      if (response.success) {
        setAdmins(response.admins);
      } else {
        console.error(response.message);
      }
    };
    loadAdmins();
  }, []);

  // Добавление администратора
  const handleAddAdmin = async () => {
    if (!login || !password) {
      alert("Логин и пароль обязательны");
      return;
    }

    const response = await addAdmin({ login, password });
    if (response) {
      setAdmins([...admins, { login, id: response.id }]); // Обновляем локально
      setLogin("");
      setPassword("");

      window.location.reload();
    }
  };

  const handleDelete = async (id) => {
    const response = await deleteAdmin(id);
    if (response) {
      window.location.reload();
    }
  };

  const [mail, setmail] = useState("");
  const [telegram, settelegram] = useState("");

  const handleChange = (event) => {
    setmail(event.target.value);
  };
  const handleChange2 = (event) => {
    settelegram(event.target.value);
  };

  const [savedMail, setSavedMail] = useState("");
  const [savedTelegram, setSavedTelegram] = useState("");

  useEffect(() => {
    const loadfeedback = async () => {
      const response = await fetchfeedback();
      if (response.success) {
        setSavedMail(response.feedbacks.mail);
        setSavedTelegram(response.feedbacks.telegram);
      } else {
        console.error(response.message);
      }
    };
    loadfeedback();
  }, []);

  const handleSubmit = async () => {
    if (!mail || !telegram) {
      alert("Введите данные обратной связи");
      return;
    }

    const response = await sendfeedback({ mail, telegram });
    if (response.success) {
      setmail("");
      settelegram("");
    }

    const loadfeedback = async () => {
      const response = await fetchfeedback();
      if (response.success) {
        setSavedMail(response.feedbacks.mail);
        setSavedTelegram(response.feedbacks.telegram);
      } else {
        console.error(response.message);
      }
    };
    loadfeedback();
  };

  return (
    <main className={css["root"]}>
      <div className="container">
        <div className={css.settings__title}>
          <h1>Настройки</h1>
          <h3>Настройки администратора</h3>
        </div>

        <div className={css.settings__container}>
          <div className={css.settings__item}>
            <h2>Обратная связь</h2>
            <h3>
              Данные для обратной связи, которые отображаются на главной
              странице:
            </h3>
            <ul>
              <li>
                Эл.почта: <span className={css.feedback}>{savedMail}</span>
              </li>
              <li>
                Номер телефона:{" "}
                <span className={css.feedback}>{savedTelegram}</span>
              </li>
            </ul>
            <h3>Поменять данные для обратной связи</h3>
            <input
              type="email"
              placeholder="Email"
              name="mail"
              value={mail}
              onChange={handleChange}
            />
            <input
              type="text"
              placeholder="Номер телефона "
              name="telegram"
              value={telegram}
              onChange={handleChange2}
            />
            <button className={css.settings__btn} onClick={handleSubmit}>
              Сохранить
            </button>
          </div>
          <div className={css.settings__item}>
            <h2>Настройки администраторов</h2>
            <h3>Список всех администраторов</h3>
            <ul className={css.adminList}>
              {admins.map((admin) => (
                <li key={admin.id} className={css.adminList__item}>
                  {admin.login}
                  <button
                    onClick={(e) => handleDelete(admin.id)}
                    className={css.adminList__delete}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zm2-4h2V8H9zm4 0h2V8h-2z"
                      />
                    </svg>
                  </button>
                </li>
              ))}
            </ul>
            <h3>Добавить администратора</h3>
            <input
              type="text"
              placeholder="Логин"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
            />
            <input
              type="password"
              placeholder="Пароль"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button onClick={handleAddAdmin} className={css.settings__btn}>
              Добавить
            </button>
          </div>
        </div>
      </div>
    </main>
  );
};

export default AdminSettings;
